import { Autocomplete, TextField } from '@mui/material';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Enum } from '~/data/enums';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  terminationReasons: Enum[];
  index: number;
  hasEndOfEmployment: boolean;
  disabled?: boolean;
};

export const TerminationReasonComponent = (props: Props) => {
  const {
    control,
    terminationReasons,
    index,
    getValues,
    hasEndOfEmployment,
    disabled,
  } = props;

  const { t } = useTranslation();
  const requiredText = t('fieldIsRequired');

  const { filterActiveEnumsByFormSelections } =
    useFilterActiveEnumsByFormSelections({
      control,
      index,
      getValues,
    });

  const filteredOptions = filterActiveEnumsByFormSelections(terminationReasons);

  return (
    <Controller
      control={control}
      name={`schedule.${index}.employment.fEmplTerminationReason`}
      rules={{
        required: hasEndOfEmployment && requiredText,
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          options={filteredOptions}
          disabled={disabled}
          getOptionLabel={(o) => o?.name || ''}
          isOptionEqualToValue={(o, v) => o?.code === v?.code}
          onChange={(_, value) => onChange(value?.code || '')}
          value={filteredOptions.find((o) => o?.code === value) || null}
          size={'small'}
          data-testid="termination-reason-autocomplete"
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('laTerminationReason')}
              required={hasEndOfEmployment}
              error={!!error}
              helperText={error?.message}
              data-testid="termination-reason-input"
              InputLabelProps={{ shrink: true }}
            />
          )}
          fullWidth={true}
        />
      )}
    />
  );
};
